import {FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {CerfDetails} from '../../interfaces/CerfDetails';
import {numberFormatter} from '../../../utilities/utils';

const costsEqualValidator = (group: FormGroup) => {
  const totalCosts = group.controls['total_costs'];
  const totalExpenditureCosts = group.controls['total_expenditure_costs'];
  if (totalCosts.value && totalExpenditureCosts.value) {
    if (totalCosts.value === totalExpenditureCosts.value) return null;
    else return {'costsNotEqual': true};
  } else return null;
};

const formatCurrency = (value: string) => {
  if (value || Number(value) === 0) {
    return numberFormatter.format(Number(value));
  } else {
    return numberFormatter.format(0);
  }
};

export const createCerfForm = (formBuilder: FormBuilder, formValues: CerfDetails, disabled: boolean, cerfNumberDisabled: boolean) =>
  formBuilder.group({
    cerf_number: new FormControl({ value: formValues.cerf_number, disabled: cerfNumberDisabled}),
    level: formValues.level,
    name: new FormControl({ value: formValues.name, disabled: disabled}, Validators.required),
    type: new FormControl({ value: formValues.type, disabled: disabled}, Validators.required),
    business_unit: new FormControl({ value: formValues.business_unit, disabled: disabled}, Validators.required),
    location: new FormControl({ value: formValues.location, disabled: disabled}, Validators.required),
    prior_year_project: new FormControl({ value: formValues.prior_year_project, disabled: disabled}, Validators.required),
    budgeted: new FormControl({ value: formValues.budgeted, disabled: disabled}, Validators.required),
    description: new FormControl({ value: formValues.description, disabled: disabled}, Validators.required),

    basic_costs: new FormControl({ value: formatCurrency(formValues.basic_costs), disabled: disabled}, Validators.required),
    other_costs: new FormControl({ value: formatCurrency(formValues.other_costs), disabled: disabled}, Validators.required),
    freight_costs: new FormControl({ value: formatCurrency(formValues.freight_costs), disabled: disabled}, Validators.required),
    taxes: new FormControl({ value: formatCurrency(formValues.taxes), disabled: disabled}, Validators.required),
    total_costs: new FormControl({value: formatCurrency(formValues.total_costs), disabled: true}, Validators.required),

    january_march_expenditure_costs:
      new FormControl({value: formatCurrency(formValues.january_march_expenditure_costs), disabled: disabled}, Validators.required),
    april_june_expenditure_costs:
      new FormControl({value: formatCurrency(formValues.april_june_expenditure_costs), disabled: disabled}, Validators.required),
    july_september_expenditure_costs:
      new FormControl({value: formatCurrency(formValues.july_september_expenditure_costs), disabled: disabled}, Validators.required),
    october_december_expenditure_costs:
      new FormControl({value: formatCurrency(formValues.october_december_expenditure_costs), disabled: disabled}, Validators.required),
    next_year_expenditure_costs:
      new FormControl({value: formatCurrency(formValues.next_year_expenditure_costs), disabled: disabled}, Validators.required),
    total_expenditure_costs:
      new FormControl({value: formatCurrency(formValues.total_expenditure_costs), disabled: true}, Validators.required)
  }, {validator: costsEqualValidator});




// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/cerf/components/cerf-form/cerf-details-form..ts